import React, { useEffect, useState, FC } from 'react'
import dayjs from 'dayjs';
import 'dayjs/locale/th';          // โหลด locale ไทย

interface JackpotProps {
    data: number;
}

const getUpdateLabel = () =>
    `อัปเดตล่าสุดเมื่อ ${dayjs().locale('th').format('D MMM YYYY HH:mm:ss')}`;
const JackpotWidget: FC<JackpotProps> = ({ data }) => {

    const [jackpot, setJackpot] = useState(data);
    const [lastUpdate, setLastUpdate] = useState(getUpdateLabel());

    useEffect(() => {
        const timer = setInterval(() => {
            const increase = Math.floor(Math.random() * 201) + 300; // +300-500
            setJackpot((prev) => prev + increase);
            setLastUpdate(getUpdateLabel());
        }, 1_000);

        return () => clearInterval(timer);
    }, []);
    return (
        <>
            <div className="jackpot-container">
                {/* <div className="jackpot-title"><i className="fa-solid fa-trophy-star"></i> รางวัลแจ็คพอตที่จ่ายไปแล้ว</div> */}
                <div className="jackpot-title">
                    <i className="fa-solid fa-trophy-star golden-icon"></i>
                    <span className="golden-text">รางวัลแจ็คพอตที่จ่ายไปแล้ว</span>
                    <i className="fa-solid fa-trophy-star golden-icon"></i>
                </div>
                <div className="jackpot-text" id="jackpotAmount">{jackpot.toLocaleString('th-TH')} บาท</div>
                <div className="jackpot-updated-time" id="jackpotUpdateTime">{lastUpdate}</div>
            </div>
        </>
    )
}

export default JackpotWidget
